import React from 'react';

import Icon from '@expo/vector-icons/FontAwesome';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';

import * as BoxC from './_ccbBoxC';

const _IconCell = React.memo((pDz: ht.iconCz) => {

  const _abtType = pDz.abtType ?? 'nmlz';
  const _abtz = ica.iconAbtz[_abtType] ? ica.iconAbtz[_abtType]() : {};

  let _o = (
    cr.c(Icon, {
      key: 'Icon.root',
      ... _abtz.iconPtyz,
      ... pDz.iconPtyz,
    })
  );

  if (hf.f(pDz.boxStlz)) {
    _o = (
      cr.c(BoxC.N, {
        key: -10,
        boxStlz: {
          ... _abtz.boxStlz,
          ... pDz.boxStlz,
        },
        oClds: _o
      })
    );
  }

  return _o;
});

export const N = _IconCell;
